import React from 'react'
export const nl2br = (string, span = false) => {
  // Check if string exists and is actually a string
  if (!string || typeof string !== 'string') {
    return null
  }

  const text = string.split('\n')
  return text.map((line, index) => {
    // const newLine = line.replace(widowRegex, '$1\u00A0')
    return (
      <React.Fragment key={index}>
        {span ? <span>{line}</span> : line}
        {!span && index + 1 < text.length && <br />}
      </React.Fragment>
    )
  })
}
